import React from 'react';
import PropTypes from 'prop-types';
import Stack from '@mui/material/Stack';
import { DataGridPaper } from 'components/Ui/styled';
import { getNoteHistoryDataGrid } from './NotesDataGrid';
import { renderCellExpand } from 'components/Common/GridCell/GridCellExpand';

const NotesList = ({ row: rowProp }) => {
  const { noteHistory } = rowProp;

  const columns = [
    {
      headerName: 'Label',
      field: 'label',
      flex: 1,
    },
    {
      headerName: 'Note',
      field: 'note',
      width: 400,
      renderCell: renderCellExpand,
    },
    {
      headerName: 'In Compliance',
      field: 'inCompliance',
      type: 'boolean',
      flex: 1,
    },
    {
      headerName: 'Added At',
      field: 'addedAt',
      flex: 1,
    },
    {
      headerName: 'Added By',
      field: 'addedBy',
      renderCell: renderCellExpand,
      width: 200,
    },
  ];

  return (
    <Stack sx={{ py: 2 }} direction='column'>
      <DataGridPaper>
        <Stack direction='column' spacing={1}>
          {getNoteHistoryDataGrid(columns, noteHistory)}
        </Stack>
      </DataGridPaper>
    </Stack>
  );
};

NotesList.propTypes = {
  row: PropTypes.object.isRequired,
};

export default NotesList;
